import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Login from "../Common/Login";
import PrivateRoute from "./PrivateRoute";
import PageNotFound from "../Common/PageNotFound";
import { useSelector } from "react-redux";
import Blogs from "../MyComponents/Blogs";
import News from "../MyComponents/News";
import Country from "../MyComponents/Country";
import HealthCenter from "../MyComponents/HealthCenter";
import Test from "../MyComponents/Test";
import Department from "../MyComponents/Department";
import Trading from "../MyComponents/Trading";
import Doctors from "../MyComponents/Doctors";
import Labs from "../MyComponents/Labs";
import Patient from "../MyComponents/Patient";
import Restaurant from "../MyComponents/Restaurant";
import NewDashboard from "../MyComponents/NewDashboard";
import Faq from "../MyComponents/Faq";
import TradingCategory from "../MyComponents/TradingCategory";
import { useTranslation } from 'react-i18next';
import OutsideJordan from "../MyComponents/OutsideJordan";
import OtherServices from "../MyComponents/OtherServices";

export default function Routing() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const userType = useSelector((state) => state.auth?.user?.userType);
  const { accessToken } = useSelector((state) => state.auth);

  return (
    <div className={`app ${isRTL ? 'rtl' : 'ltr'}`}>
      <Router>
        <Routes>


          <Route
            path="/"
            element={
              <PrivateRoute>
                <NewDashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/blogs"
            element={
              <PrivateRoute>
                <Blogs />
              </PrivateRoute>
            }
          />

          <Route
            path="/restaurant"
            element={
              <PrivateRoute>
                <Restaurant />
              </PrivateRoute>
            }
          />
          <Route
            path="/news"
            element={
              <PrivateRoute>
                <News />
              </PrivateRoute>
            }
          />
          <Route
            path="/other-services"
            element={
              <PrivateRoute>
                <OtherServices />
              </PrivateRoute>
            }
          />


          <Route
            path="/country"
            element={
              <PrivateRoute>
                <Country />
              </PrivateRoute>
            }
          />
          <Route
            path="/test"
            element={
              <PrivateRoute>
                <Test />
              </PrivateRoute>
            }
          />
          <Route
            path="/department"
            element={
              <PrivateRoute>
                <Department />
              </PrivateRoute>
            }
          />


          


          <Route
            path="/doctors"
            element={
              <PrivateRoute>
                <Doctors />
              </PrivateRoute>
            }
          />

          <Route
            path="/patient"
            element={
              <PrivateRoute>
                <Patient />
              </PrivateRoute>
            }
          />

          <Route
            path="/labs"
            element={
              <PrivateRoute>
                <Labs />
              </PrivateRoute>
            }
          />

          <Route
            path="/trading"
            element={
              <PrivateRoute>
                <Trading />
              </PrivateRoute>
            }
          />
          <Route
            path="/health-center"
            element={
              <PrivateRoute>
                <HealthCenter />
              </PrivateRoute>
            }
          />
          <Route
            path="/faq"
            element={
              <PrivateRoute>
                <Faq />
              </PrivateRoute>
            }
          />

          <Route
            path="/trading-category"
            element={
              <PrivateRoute>
                <TradingCategory />
              </PrivateRoute>
            }
          />

          <Route
            path="/outside-jordan"
            element={
              <PrivateRoute>
                <OutsideJordan />
              </PrivateRoute>
            }
          />





          <Route path="/login" element={<Login />} />



          <Route path="*" element={<PageNotFound />} />


          
        </Routes>
      </Router>
    </div>
  );
}
